var _path, _line, _line2, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrownTorque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1543 27.9687C18.2819 27.9896 18.4043 28 18.5266 28C19.4681 28 20.266 27.3419 20.4894 26.4384C21.2766 23.2317 23.5 15.5649 23.5 13.5803C23.5 11.0525 21.4096 9 18.8351 9C18.1809 9 17.5585 9.13057 16.9947 9.37081C16.5213 9.56927 16.0106 9.67372 15.5 9.67372C14.9894 9.67372 14.4787 9.57449 14.0053 9.37081C13.4415 9.13057 12.8191 9 12.1649 9C9.59043 9 7.5 11.0525 7.5 13.5803C7.5 15.3194 9.70213 23.2317 10.4734 26.4384C10.6915 27.3419 11.4894 28 12.4362 28C12.5585 28 12.6862 27.9896 12.8138 27.9634C13.7713 27.7859 14.4362 26.9241 14.4362 25.9684V23.7905C14.4362 22.9601 14.9043 22.5006 15.484 22.5006C16.0638 22.5006 16.5319 22.9601 16.5319 23.5294V25.9684C16.5319 26.9241 17.1968 27.7911 18.1596 27.9687H18.1543Z",
    fill: "#70A4D4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.576,
    y1: 26.735,
    x2: 25.576,
    y2: 10.735,
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 18.868,
    y2: -0.5,
    transform: "matrix(0.529999 0.847998 0.847998 -0.529999 6 11)",
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10L25.2685 4.27302L20.6745 7.77L26 10ZM6 10L11.1027 7.29888L6.2121 4.23039L6 10ZM23.5862 6.02845C21.8882 4.67323 19.31 3.5 15.5001 3.5L15.5001 4.5C19.0871 4.5 21.4445 5.59858 22.9624 6.81003L23.5862 6.02845ZM15.5001 3.5C11.9217 3.5 9.5824 4.53562 8.06983 5.80572L8.71289 6.57154C10.0245 5.47015 12.1283 4.5 15.5001 4.5L15.5001 3.5Z",
    fill: "#1A1A1A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 26.5,
    r: 1.5,
    transform: "rotate(-180 15.5 26.5)",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrownTorque);
export default __webpack_public_path__ + "static/media/Icon_Crown_Torque.bd6215b1ce3aae97149e52f17316af34.svg";
export { ForwardRef as ReactComponent };